<template>
  <v-row>
    <v-col>
      サインイン、サインアップすることであなたは
      <a href="https://www.seaplus.style/termsofservice">利用規約</a>
      と
      <a href="https://www.seaplus.style/privacypolicy">プライバシーポリシー</a>
      に同意したことになります。
    </v-col>
  </v-row>
</template>

<script>
export default {}
</script>
